import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  animationMorph,
  datasetXY,
  xBand,
  yLinear,
  initLine,
  lineAreaAnimation,
  backgroundColor,
  label,
  tooltip,
  discreteLegend,
  color,
  initPivot,
  datasetPivot,
  pivotDiscreteLegend,
  pivotIndicators,
  pivotAdapter,
  pivotIndicatorsAsRow,
  pivotGridStyle,
  pivotColumnDimensions,
  pivotRowDimensions,
  annotationPoint,
  annotationDifferenceLine,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
  pointStyle,
  lineStyle,
  verticalCrosshairLine,
  pointStateDimensionHover,
  progressive,
  colorAdapter,
  linearColor,
  colorLegend,
  colorLineStyleFill,
  colorPointStyleFill,
  pivotColorLegend,
  pivotTitle,
  pivotAxisStyle,
  splitLine,
  dimensionLinkage,
  brush,
  fontFamilyTheme,
  regionPadding,
} from '../pipes'

const line: VChartSpecPipeline = [
  fontFamilyTheme,
  initLine,
  lineAreaAnimation,
  regionPadding,
  colorAdapter(color, linearColor),
  backgroundColor,
  datasetXY,
  animationMorph,
  progressive,
  xBand,
  yLinear,
  brush,
  verticalCrosshairLine,
  colorAdapter(discreteLegend, colorLegend),
  colorPointStyleFill(pointStyle),
  pointStateDimensionHover,
  colorLineStyleFill(lineStyle),
  label,
  tooltip({ titleEncoding: 'x' }),
  annotationPoint,
  annotationDifferenceLine,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
  splitLine,
]

const pivotLine: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  pivotIndicatorsAsRow,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initLine,
    lineAreaAnimation,
    regionPadding,
    colorAdapter(color, linearColor),
    backgroundColor,
    datasetXY,
    animationMorph,
    progressive,
    xBand,
    pivotAxisStyle(yLinear),
    brush,
    verticalCrosshairLine,
    colorPointStyleFill(pointStyle),
    pointStateDimensionHover,
    colorLineStyleFill(lineStyle),
    label,
    tooltip({ titleEncoding: 'x' }),
    annotationPoint,
    annotationDifferenceLine,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationArea,
    splitLine,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
  dimensionLinkage,
]

export const lineSpecPipeline = [pivotAdapter(line, pivotLine)]
